/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const CloudCircleBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM6.735 13.135c0 1.087.923 1.969 2.062 1.969h6.188c1.519 0 2.75-1.175 2.75-2.625s-1.231-2.625-2.75-2.625c-.071 0-.142.002-.211.007a.278.278 0 0 1-.258-.131c-.596-.973-1.703-1.626-2.969-1.626-1.8 0-3.276 1.32-3.425 3a.285.285 0 0 1-.172.236c-.717.308-1.215.996-1.215 1.795Z" /></svg>);
const CloudCircle = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={CloudCircleBase} {...rest} ref={ref} />);
export default CloudCircle;